"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DropdownToggle = require("react-overlays/DropdownToggle");

var _BaseButton = _interopRequireDefault(require("./BaseButton"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const ButtonStyled = _styledComponents.default.button.withConfig({
  displayName: "FilterButton__ButtonStyled",
  componentId: "design-system__c7ddup-0"
})(["", ";"], _BaseButton.default);

const FilterButton = _ref => {
  let {
    id,
    children,
    active,
    icon
  } = _ref;
  const [props, {
    toggle
  }] = (0, _DropdownToggle.useDropdownToggle)();
  const {
    ref,
    'aria-haspopup': ariaHasPopup,
    'aria-expanded': ariaExpanded
  } = props;

  if (icon) {
    return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      ref: ref,
      "aria-haspopup": ariaHasPopup,
      "aria-expanded": ariaExpanded,
      type: icon,
      iconSize: "18",
      id: id,
      onClick: toggle
    });
  }

  return /*#__PURE__*/_react.default.createElement(ButtonStyled, {
    type: "button",
    className: active ? 'btn btn-primary active' : 'btn btn-primary',
    id: id,
    onClick: toggle,
    ref: ref,
    "aria-haspopup": ariaHasPopup,
    "aria-expanded": ariaExpanded
  }, children);
};

FilterButton.propTypes = {
  id: _propTypes.default.string,
  children: _propTypes.default.node,
  ref: _propTypes.default.func,
  'aria-haspopup': _propTypes.default.bool,
  'aria-expanded': _propTypes.default.bool,
  active: _propTypes.default.bool,
  icon: _propTypes.default.string
};
FilterButton.defaultProps = {
  id: undefined,
  ref: undefined,
  children: undefined,
  'aria-haspopup': undefined,
  'aria-expanded': undefined,
  active: false,
  icon: undefined
};
var _default = FilterButton;
exports.default = _default;